import { render, staticRenderFns } from "./withdrawMoney.vue?vue&type=template&id=40c07e60&scoped=true"
import script from "./withdrawMoney.vue?vue&type=script&lang=js"
export * from "./withdrawMoney.vue?vue&type=script&lang=js"
import style0 from "./withdrawMoney.vue?vue&type=style&index=0&id=40c07e60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c07e60",
  null
  
)

export default component.exports